'use strict'

import ReplaceImg from './components/ReplaceImg.js';
import PageScroll from './components/PageScroll.js';
import Fullpage from './components/Fullpage.js';
import Preload from './components/Preload.js';
import ClickAddClass from './components/ClickAddClass.js';
import HoverAddClass from './components/HoverAddClass.js';
import Slider from './components/Slider.js';
import Hamburger from './components/Hamburger.js';
import OpenAnimation from './components/OpenAnimation.js';
import UserAgentChecker from './components/UserAgentChecker.js';

// import Vivus from 'vivus';



// import InView from './components/InView.js';
// new Preload();
let ua = new UserAgentChecker();
setTimeout(()=>{
  new ReplaceImg();
}, 500)

new PageScroll();
new ClickAddClass();
new HoverAddClass();
new Hamburger();

let top = document.getElementsByClassName('index');
let about = document.getElementsByClassName('about');
let stage = document.getElementsByClassName('stage');
if(top.length === 0 && about.length ===0 && stage.length === 0) {
  let fullpage = new Fullpage();




  setTimeout(()=>{
    let other_h = document.getElementById('OtherInfo').clientHeight;
    // let other_h = document.getElementsByClassName('slide__body')[0].offsetHeight;
    let slide_h = document.getElementById('FooterEpisode').clientHeight;
    let footer_h = document.getElementById('footerPc').clientHeight;

    document.getElementById('slideEndInner').style.height = other_h + slide_h + footer_h + 105 + 'px'

    fullpage.init();


    $(function(){
      $(window).keydown(function(event){
        // falseを返却してキー入力処理をキャンセル
        let code = event.keyCode;
        if(code == 37 || code == 38 || code == 39 || code == 40) {
          return false;
        }

      });
    });
  },1000)
}
setTimeout(function() {
  new Slider();
}, 400);


if(top.length == 1) {
  let ram = Math.floor( Math.random() * 7 ) + 1;
  let kv = document.getElementsByClassName('l-index-kv')[0];
  if(ua.isPC){
    kv.style.backgroundImage = "url('/assets/images/pc/top/pc_top_" + ram +".jpg')"
  } else {
    kv.style.backgroundImage = "url('/assets/images/sp/top/sp_top_" + ram +".jpg')"
  }


}



// WEBPACK FOOTER //
// ./src/assets/js/app.js